import React, { createContext, useContext, useState, useEffect } from "react";
import {
  login as apiLogin,
  refreshAccessToken,
  getUserDetailsByEmail,
} from "../services/authServices";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(
    localStorage.getItem("accessToken")
  );
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  const saveToken = (token) => {
    localStorage.setItem("accessToken", token);
    //axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setAccessToken(token);
  };

  const login = async (email, password) => {
    const data = await apiLogin(email, password);
    saveToken(data.token);
    localStorage.setItem("accessToken", data.token);
    localStorage.setItem("refreshToken", data.refreshToken);
    localStorage.setItem(
      "userDetails",
      JSON.stringify({ displayName: data.displayName, username: data.username })
    );
    return await getCurrentUser();
  };

  const logout = () => {
    setAccessToken(null);
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userDetails");
  };

  const refreshToken = async () => {
    const token = localStorage.getItem("refreshToken");
    if (!token) return logout();
    try {
      const currentUser = getCurrentUser();
      const payload = {
        refreshToken: token,
        username: currentUser.username
      };
      const data = await refreshAccessToken(payload);
      setAccessToken(data.accessToken);
      localStorage.setItem("accessToken", data.accessToken);
    } catch {
      logout();
    }
  };

  const getCurrentUser = async () => {
    const user = JSON.parse(localStorage.getItem("userDetails"));
    if (!user) {
      return null;
    }
    var currentUser = await getUserDetailsByEmail(user.username);
    setUser(currentUser);
    return currentUser;
  };

  useEffect(() => {
    const interval = setInterval(refreshToken, 1000 * 60 * 14);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const initialize = async () => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        try {
          saveToken(token);
          await getCurrentUser();
        } catch (err) {
          logout(); // Invalid token, clear session
        }
      }
      setLoading(false);
    };

    initialize();
  }, []);

  return (
    <AuthContext.Provider value={{ accessToken, user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
